import { Component, OnInit } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexXAxis,
  ApexPlotOptions
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  colors: string[]
};

@Component({
  selector: 'app-special-deals-report',
  templateUrl: './special-deals-report.component.html',
  styleUrls: ['./special-deals-report.component.css']
})
export class SpecialDealsReportComponent implements OnInit {
  public chartOptions: Partial<ChartOptions> = {
    series: [
      {
        name: "basic",
        data: [20, 30, 48, 70, 90]
      }
    ],
    chart: {
      type: "bar",
      height: 270
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: [],
    },
    colors: [
      "rgb(255,177,193))", "rgb(154,208,245)", "rgb(255,230,170)",
      "rgb(165,223,223)", "rgb(204,178,255)"
    ]
  };
  userList = ["120,000", "500,000", "1,000,000", "1,500,000", "2,000,000"];
  // apps = ['MyXalary', 'Notch', 'Myx3', 'MyX3leasing', 'Loan35'];
  oppurntityChart: Partial<ChartOptions>;
  timeToWinChart: Partial<ChartOptions>;
  constructor() {
    this.oppurntityChart = {
      xaxis: {
        categories: [...this.userList]
      }
    }
    this.timeToWinChart = {
      plotOptions: {
        bar: {
          horizontal: false,
          distributed: true,
          // columnWidth: '40%',
        }
      },
      xaxis: {
        // categories: [...this.apps]
      }
    }
  }

  ngOnInit() {
  }

}
